import { Model as ORMModel, attr, many, fk } from 'redux-orm'
import { Types } from '@fedsim/actions'

export class Reign extends ORMModel {
  static get fields() {
    return {
      id: attr(),
      name: attr({ getDefault: () => '' }),
      desc: attr({ getDefault: () => '' }),
      image: attr({ getDefault: () => '' }),
      wrestlerIds: many({
        to: 'Wrestler',
        as: 'wrestlers',
        relatedName: 'ReignWrestlers'
      }),

      championshipId: fk({
        to: 'Championship',
        as: 'championship',
        relatedName: 'ReignChampionship'
      }),

      defenses: attr({ getDefault: () => 0 }),

      startDate: attr({ getDefault: () => new Date() }),
      endDate: attr({ getDefault: () => null })
    }
  }

  static reducer(action, Reign, session) {
    let item
    switch (action.type) {
      case Types.RESET:
      case Types.RESET_REIGNS:
        session.Reign.all()
          .toModelArray()
          .forEach(item => item.delete())
        break
      case Types.ADD_REIGN:
      case Types.CREATE_REIGN: {
        Reign.upsert(action.payload)
        break
      }
      case Types.UPDATE_REIGN:
        item = Reign.withId(action.payload.id)
        if (item) {
          item.update(action.payload)
        }
        break
      case Types.GENERATE_REIGNS:
        action?.payload.forEach(newItem => {
          session.Reign.upsert(newItem)
        })
        break
      case Types.DELETE_REIGN: {
        Reign.withId(action.payload.id).delete()
        break
      }
    }
  }
}

export default Reign
